export default __webpack_public_path__ + "static/media/Info-page-explorations.d77553cb.jpg";